import { render, staticRenderFns } from "./SysSupplier.vue?vue&type=template&id=63437c08&scoped=true&"
import script from "./SysSupplier.vue?vue&type=script&lang=js&"
export * from "./SysSupplier.vue?vue&type=script&lang=js&"
import style0 from "./SysSupplier.vue?vue&type=style&index=0&id=63437c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63437c08",
  null
  
)

component.options.__file = "SysSupplier.vue"
export default component.exports